<template>
  <v-row density="comfortable">
    <v-col class="d-flex flex-column ga-1">
      <sf-alert-error v-for="validationError in validationStatus.errors" :key="validationError">
        {{ validationError }}
      </sf-alert-error>
      <sf-alert-warning
        v-for="validationWarning in validationStatus.warnings"
        :key="validationWarning"
      >
        {{ validationWarning }}</sf-alert-warning
      >
      <sf-alert-info v-for="validationInfo in validationStatus.infos" :key="validationInfo">
        {{ validationInfo }}</sf-alert-info
      >
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import SfAlertError from '@/components/alerts/SfAlertError.vue'
import SfAlertWarning from '@/components/alerts/SfAlertWarning.vue'
import SfAlertInfo from '@/components/alerts/SfAlertInfo.vue'
import { PropType } from 'vue'
import { OrderValidationStatus } from '@/types/index'

defineProps({
  validationStatus: {
    type: Object as PropType<OrderValidationStatus>,
    required: true
  }
})
</script>
